/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */

'use strict';

/**
 * The public interface to React Relay.
 */
module.exports = {
  QueryRenderer: require('./ReactRelayQueryRenderer'),

  MutationTypes: require('relay-runtime').MutationTypes,
  RangeOperations: require('relay-runtime').RangeOperations,

  applyOptimisticMutation: require('relay-runtime').applyOptimisticMutation,
  commitLocalUpdate: require('relay-runtime').commitLocalUpdate,
  commitMutation: require('relay-runtime').commitMutation,
  createFragmentContainer: require('./ReactRelayFragmentContainer').createContainer,
  createPaginationContainer: require('./ReactRelayPaginationContainer').createContainer,
  createRefetchContainer: require('./ReactRelayRefetchContainer').createContainer,
  fetchQuery: require('relay-runtime').fetchQuery,
  graphql: require('relay-runtime').graphql,
  requestSubscription: require('relay-runtime').requestSubscription
};


//////////////////
// WEBPACK FOOTER
// ./~/react-relay/lib/ReactRelayPublic.js
// module id = 2434
// module chunks = 3